import React from "react";
import { useHistory } from "react-router";
import { message } from "antd";
import CartItem from "./CartItem";

const CartList = ({ cart, checkoutButton, checkoutPage }) => {
  const history = useHistory();

  const getTotal = () => {
    let total = cart.reduce((acc, cart) => {
      return acc + cart.product.cost * cart.qty;
    }, 0);
    return total;
  };

  const onSubmit = () => {
    if (cart.length) {
      history.push("/checkout");
    } else {
      message.error("please select product.");
    }
  };

  const getQuantity = () => {
    let total = cart.reduce((acc, cart) => {
      return acc + cart.qty;
    }, 0);
    return total;
  };

  return (
    <div id="cartlist">
      {cart.length !== 0 && (
        <>
          {cart.map((item) => (
            <CartItem
              checkoutPage={checkoutPage}
              key={item.productId}
              cart={item}
            />
          ))}

          <div className="card mt-4">
            <div className="card-body">
              <p className="fs-3 text-center">Total</p>
              <div className="d-flex justify-content-between">
                <p className="fs-5 me-4">Products</p>
                <p className="fs-5">{getQuantity()}</p>
              </div>
              <div className="d-flex justify-content-between">
                <p className="fs-5">SubTotal</p>
                <p className="fs-5">₹{getTotal()}</p>
              </div>
              <div className="d-flex justify-content-between">
                <p className="fs-5">Shipping</p>
                <p className="fs-5">N/A</p>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <p className="fs-5">Total</p>
                <p className="fs-5">₹{getTotal()}</p>
              </div>
              {checkoutButton && (
                <div className="d-flex justify-content-center">
                  <button className="btn btn-warning" onClick={onSubmit}>
                    <i
                      className="fa fa-shopping-cart me-2"
                      aria-hidden="true"
                    ></i>
                    Checkout
                  </button>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CartList;
